import { render, staticRenderFns } from "./SchemeIcon.vue?vue&type=template&id=bd704056&"
import script from "./SchemeIcon.vue?vue&type=script&lang=js&"
export * from "./SchemeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports